import { render, staticRenderFns } from "./Simulador.vue?vue&type=template&id=0c89cc92&"
import script from "./Simulador.vue?vue&type=script&lang=js&"
export * from "./Simulador.vue?vue&type=script&lang=js&"
import style0 from "./Simulador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports